import MainButton from 'components/MainButton';
import MainCard from 'components/MainCard';
import Layout from 'Layout'
import React, { useCallback, useState } from 'react'
import SecondaryButton from 'components/SecondaryButton';
import { useNavigate, useParams } from 'react-router-dom';
import { getKategoriKegiatan, getKegByKategori, getKegiatan, searchKegiatan } from 'services/apiRoutes';
import { useEffect } from 'react';
import SkeletonMaincard from 'skeletons/SkeletonMaincard';
import HorizontalCard from 'components/HorizontalCard';
import ImKegiatan from 'assets/images/ImKegiatan.jpg'

export default function Kegiatan() {
  const {slug}=useParams()
  const [kegiatan,setKegiatan]=useState();

  const [total,setTotal]=useState();
  const [kategori,setKategori]=useState();
  const [counter,setCounter]=useState(3);
  const [loading,setLoading]= useState(false);
  const [keyword,setKeyword]=useState();
  const [active,setActive]=useState();
  const [defaultKategori,setDefaultKategori]=useState(true);


  const kegiatanAPI = useCallback(async(limit,offset,slg)=>{
    setLoading(true);
    const res = await getKegiatan(limit,offset,slg);
    if (res.error) {
      return res.message;
    }else{
      const {data} = res.data;
      const { jumlahData } = res.data;
      setTotal(jumlahData)
      setKegiatan(data);
      setLoading(false);
      setDefaultKategori(true);
      setActive(null);
    }
  },[])
 
  const kategoriKegiatanAPI = useCallback(async()=>{
    const res = await getKategoriKegiatan(slug);
    if (res.error) {
      return res.message;
    }else{
      const {data} = res.data;
      setKategori(data);
    }
  },[slug])

    
    const kegByKategoriAPI = useCallback(async ( uuid,indexBtn) => {
      setLoading(true);
      const res = await getKegByKategori(20,0, uuid,slug);
      if (res.error) {
        return res.message;
      } else {
        setLoading(false);
        const { data } = res.data;
        setKegiatan(data);
        setActive(indexBtn);
        setDefaultKategori(false);
      }
    }, [slug]);

  const handleCounter = () =>{
    setCounter(counter+3)
  }

      const searchKegAPI = useCallback(async (limit, offset, keyword) => {
        setLoading(true);
        const res = await searchKegiatan(limit, offset, keyword,slug);
        if (res.error) {
          return res.message;
        } else {
          setLoading(false);
          const { data } = res.data;
          setKegiatan(data);
        }
      }, [slug]);

      const seacrhKeg = () => {
        searchKegAPI(100, 0, keyword);
      };

      const handleKeypress = (e) => {
        if (e.key === "Enter") {
          searchKegAPI(100, 0, keyword);
        }
      };

  useEffect(() => {
    kegiatanAPI(counter, 0,slug);
    kategoriKegiatanAPI();
  }, [kegiatanAPI, kategoriKegiatanAPI,counter,keyword,slug]);

  const navigate = useNavigate();
  return (
    <>
      <Layout active="kegiatan">
        <div className="px-5 xl:pt-44 pt-28 kegiatan-wrapper xl:px-99">
          <h1 className="text-2xl font-bold xl:mb-20 mb-14 xl:text-7xl">
            Kegiatan Gampong
          </h1>
          <div className="space-y-24">
            <HorizontalCard
              // desc="90% Masyarakat Gampong Geulanggang teungoh adalah Petani"
              title="Kegiatan Gampong"
              img={ImKegiatan}
            />
          </div>
          <div className="mt-[78px] font-bold text-sm">Cari kegiatan:</div>
          <input
            type="text"
            onChange={(e) => setKeyword(e.target.value)}
            onKeyPress={handleKeypress}
            placeholder="Cari Kegiatan"
            className="px-5 py-3 my-4 border seacrh rounded-2xl focus:outline-none xl:w-[994px] mr-4 w-full focus:ring-2 focus:ring-primary focus:border-none"
          />
          <MainButton label="Cari" onClick={() => seacrhKeg()} />
          {kegiatan?.length !== 0 ? null : (
            <h1 className="font-bold">{`"${keyword}" Tidak Ditemukan`}</h1>
          )}
          <div className="flex mt-[78px] items-center space-x-6 overflow-x-scroll xl:overflow-x-hidden">
            <div className="text-sm font-bold">Filter</div>
            {kategori
              ? kategori.map((item, index) => (
                  <MainButton
                    activeBtn={active === index ? true : false}
                    secondType
                    label={item.nama}
                    key={index}
                    onClick={() => kegByKategoriAPI(item.uuid, index)}
                  />
                ))
              : null}
            <MainButton
              secondType
              activeBtn={defaultKategori}
              label="Semua"
              key={53653635}
              onClick={() => kegiatanAPI(100, 0,slug)}
            />
          </div>
          <div className="xl:grid-cols-3 md:grid-cols-2 md:gap-2 md:grid mt-14 content xl:space-y-0">
            {!loading
              ? kegiatan?.map((item, index) => (
                  <MainCard
                    key={index}
                    title={item?.nama}
                    label={
                      item?.list_kategori_kegiatan_obj[0]
                        ? item?.list_kategori_kegiatan_obj[0]?.kategori_obj
                            ?.nama
                        : ""
                    }
                    img={item?.url_gambar}
                    onClick={() => navigate(`/${slug}/postkegiatan/${item.uuid}`)}
                  />
                ))
              : [1, 2, 3, 4, 5, 6].map((i) => <SkeletonMaincard key={i} />)}
          </div>
          <div className="flex items-center justify-center py-32 loadMore">
            {counter >= total ? (
              <h1 className="font-bold">Sudah mentok!</h1>
            ) : (
              <SecondaryButton
                label="Lebih Banyak"
                onClick={() => handleCounter()}
                loading={loading}
              />
            )}
          </div>
        </div>
      </Layout>
    </>
  );
}
